import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { useFilters } from '../../../../providers/Filters/useFilters';
import { ordersSelector } from '../../../../redux/selectors/orders';
import { ButtonClear } from '../../../../components/Buttons';
import {
  FiltersGroup,
  FilterCharge,
  FilterMode,
  FilterCreated,
  FilterProfit,
  FilterProviders,
  FilterQuantity,
  FilterService,
  FilterSource,
  FilterFailReason,
} from '../../../../components/Filters';

import {
  ordersUpdateFilterFailReason,
  ordersUpdateFilterMode,
  ordersUpdateFilterProviders,
  ordersUpdateFilterServices,
  ordersUpdateFilterSource,
} from '../../../../services/endpoints/orders';

const Filters = () => {
  const {
    config,
    filters,
  } = useSelector((state) => ordersSelector(state));

  const { filters: { query }, isClear, onClearFilters, onDeleteFilter } = useFilters();

  /**
   * 1 - Показываем фильтр Fail reason только при статусах All или Fail
   * 2 - Удаляем из фильтров, если статусы не равны All или Fail
   */
  const showFailReason = query?.status == null || +query?.status === 6;
  if (query.hasOwnProperty('fail_reasons') && !showFailReason) {
    onDeleteFilter(['fail_reasons'])
  }

  return (
    <FiltersGroup>
      <FilterCreated
        ranges={config?.date_range_filter}
        period_code={filters.period_code}
        date_from={filters.date_from}
        date_to={filters.date_to}
      />
      {config?.access?.see_provider
        ? (
          <FilterProviders
            updateService={ordersUpdateFilterProviders}
            data={config?.providers}
          />
        ) : null }
      <FilterService
        updateService={ordersUpdateFilterServices}
        data={config?.services}
      />
      <FilterMode
        updateService={ordersUpdateFilterMode}
        data={config?.modes}
      />
      {!config?.fields?.charge && !config?.fields?.cost ? null : <FilterProfit /> }
      {config?.fields?.charge ? <FilterCharge /> : null }
      <FilterSource
        updateService={ordersUpdateFilterSource}
        data={config?.sources}
      />
      <FilterQuantity />
      {config?.access?.details && showFailReason
        ? (
          <FilterFailReason
            updateService={ordersUpdateFilterFailReason}
            data={config?.fail_reasons}
          />
        ) : null}
      <ButtonClear
        disabled={!isClear}
        onClick={() => onClearFilters()}
      >
        Clear filters
      </ButtonClear>
    </FiltersGroup>
  )
}

export default memo(Filters);
